import { render } from "./Proposals.vue?vue&type=template&id=5eee96d4&scoped=true&ts=true"
import script from "./Proposals.vue?vue&type=script&lang=ts"
export * from "./Proposals.vue?vue&type=script&lang=ts"

import "./Proposals.vue?vue&type=style&index=0&id=5eee96d4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eee96d4"]])

export default __exports__